import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { aiSettingsService } from '../api/ai-settings.service';

export function useAiSettings() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.aiSettings, queryFn: aiSettingsService.get });
  const save = useMutation({ mutationFn: (patch: Parameters<typeof aiSettingsService.update>[0]) => aiSettingsService.update(patch),
    onSuccess: (data) => client.setQueryData(queryKeys.aiSettings, data) });
  return { query, save };
}
